import { Network } from "../../../../index"
import store from "../../../../../store"
import { formatDate } from "../../../../formating"
import APIWrapper from "../../../APIWrapper"
import { PERMISSIBLE_CLASS_TYPES } from "./constants"
import api from "../../../../../../api/axios"

export class PermissibleClassAttributes extends APIWrapper {
	constructor(attr) {
		super()
		Object.assign(this, attr)
	}
}

export default class PermissibleClass extends PermissibleClassAttributes {
	static async getAll({ employerId }) {
		const {
			data: { data }
		} = await Network.AxiosWrapperV2.get({
			url: `employer/${employerId}/class`
		})

		return data.map((item) => new this(item))
	}

	static async getAllForPlan(employerId, employerPlanId) {
		const {
			data: { data }
		} = await Network.AxiosWrapperV2.get({
			url: `employer/${employerId}/plan/${employerPlanId}/class`
		})

		return data.map((item) => new this(item))
	}

	static async getOne({ params }) {
		const data = await Network.AxiosWrapperV2.get({
			url: `employer/${params.employerId}/class/${params.permissibleClassId}`
		}).then((res) => new this(res.data))
		return data
	}

	static async create(attributes) {
		const {url} = this._getBaseUrl(attributes);
		// const payload = {
		// 	...this._getBaseUrl(attributes),
		// 	data: new this(attributes)
		// }
		const pm = await api.post(url,new this(attributes)).then((res) => new this(res))
		return pm
	}

	static async updateClass(attributes) {
		const {url} = this._getBaseUrl(attributes);
		const pm = await api.patch(url,
			new this(attributes)).then((res) => new this(res))

		return pm
	}

	static _getBaseUrl({ employerId, employerPlanId, permissibleClassId }) {
		return {
			url: `employer/${employerId}/plan/${employerPlanId}/class${permissibleClassId ? `/${permissibleClassId}` : ""}`
		}
	}

	get tableValues() {
		return {
			name: this.name,
			date: formatDate({
				data: this.createdTs,
				actions: ["display+time"]
			}),
			geography: this.predefinedClasses
				.map((predefinedClass) => PERMISSIBLE_CLASS_TYPES[predefinedClass.type])
				.join(", "),
		}
	}

	get isAdd() {
		return this.id === "add"
	}

	async save() {
		if (this.isAdd) {
			return await PermissibleClass.create(this)
		} else {
			const { data: res } = await Network.AxiosWrapperV2.send({
				...this.links.update,
				data: this
			})
			this.set(res)
			return this
		}
	}

	update(attributes) {
		return this.set(attributes).save()
	}

	async del() {
		if (this.links.delete) {
			await Network.AxiosWrapperV2.send(this.links.delete)
			await store.setNotification("notification", true, {
				msg: `Deleted class ${this.name}.`
			})
		}
	}

	toJSON() {
		return {
			...this,
		}
	}
}
